import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const LOCAL_STORAGE_KEY = 'provionline-digital-app-store';

export interface StoreData {
  [key: string]: any;
}

export interface StoreState {
  data: StoreData;
  saveToStore: (key: string, value: any) => void;
  getFromStore: (key: string) => any;
  deleteFromStore: (key: string) => void;
  resetStore: () => void;
}

export enum STORE_KEYS {
  lastVisitDate = 'lastVisitDate',
  ip = 'ip',
}

export type SessionData = Record<string, any> | undefined;

export const useStore = create<StoreState>()(
  persist(
    (set, get) => ({
      data: {},

      saveToStore: (key: string, value: any) => {
        set((state) => {
          if (state.data[key] === value) return state;

          return {
            data: { ...state.data, [key]: value },
          };
        });
      },

      getFromStore: (key: string) => {
        return get().data[key];
      },

      deleteFromStore: (key: string) => {
        set((state) => {
          if (key in state.data) {
            delete state.data[key];
          }

          return { data: state.data };
        });
      },

      resetStore: () => {
        set({ data: {} });
        localStorage.removeItem(LOCAL_STORAGE_KEY);
      },
    }),
    {
      name: LOCAL_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
